enum TootlipName {
  EditRateTitle = 'Rate could be applied from Monday only',
  ApplyAutoDiscountTitle = 'Specify the number of hours you want to auto discount per week. You can later edit this from both the Allocation and project PRP.',
  DiscountTypeTitle = "To apply a discount to Actuals, select 'Discounts'. \nTo apply a discount to Forecast, select 'Pre-Discount.'"
}

export default TootlipName;
